export default "__VITE_ASSET__DmLXL36k__"